<template>
  <div>
    <item :item="column" :value="val" @on-open="handleOpen" />
    <pad v-if="isOpen" @on-close="handleClose" @on-save="handleSave" />
  </div>
</template>

<script>
import pad from './pad'
import item from './item'
export default {
  inject: ['viewFormData'],
  props: ['column', 'value'],
  components: {
    pad,
    item
  },
  data() {
    return {
      isOpen: false,
      val: this.viewFormData?.modelData[this.column.prop] ? this.viewFormData.modelData[this.column.prop] : ''
    }
  },
  watch: {
    val(val) {
      this.viewFormData.modelData[this.column.prop] = val
    }
  },
  mounted() {

  },
  methods: {
    handleOpen() {
      this.isOpen = true
      // alert(1)
      // document.webkitCancelFullScreen()
      // alert(2)
      // if (screenfull.isEnabled) {
      //   screenfull.request()
      // }
    },
    handleClose() {
      // if (screenfull.isEnabled) {
      //   screenfull.exit()
      // }
      this.isOpen = false
    },
    handleSave(data) {
      this.val = data
      this.handleClose()
    }
  }
}
</script>
